module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app-8e343ad916e12dbef265067ea9c2ff17.webp";